import RandomNumberGenerator from "./RandomNumberGenerator"
import Game from "../Model/Game"
import config from "../config.json"
import FighterGenerator from "./FighterGenerator"
import NumberGenerator from "./NumberGenerator"
import Logger from "./Logger"

const ENEMIES_PER_LEVEL: number = 5

export default class GameGenerator {
  private cache: Record<string, Game> = {}
  constructor(
    private readonly randomNumberGenerator: RandomNumberGenerator,
    private readonly fighterGenerator: FighterGenerator,
    private readonly numberGenerator: NumberGenerator,
    private readonly logger: Logger,
  ) {}

  public generate(): Game {
    // Have to cache due to how React calls hooks multiple times.
    if (this.cache[this.randomNumberGenerator.seed] !== undefined) {
      return this.cache[this.randomNumberGenerator.seed]
    }

    const initialMe: number = this.randomNumberGenerator.randomInt(
      config.minInitial,
      config.maxInitial,
    )
    this.logger.log("[GameGenerator] initial me", initialMe)

    const enemiesValues: number[] = this.numberGenerator.generate(initialMe)

    let game: Game = new Game(
      this.randomNumberGenerator.seed,
      this.fighterGenerator.generate(initialMe, "me"),
      [],
      enemiesValues.slice(ENEMIES_PER_LEVEL),
      config.initialTime,
      1,
      initialMe,
    )

    enemiesValues.slice(0, ENEMIES_PER_LEVEL).forEach((value: number): void => {
      game = game.addNextEnemy(
        this.fighterGenerator.generate(value, "enemy", game),
      )
    })

    this.cache[this.randomNumberGenerator.seed] = game

    return game
  }
}
